import { render, staticRenderFns } from "./documentos.vue?vue&type=template&id=2a51e0b4"
import script from "./documentos.vue?vue&type=script&lang=js"
export * from "./documentos.vue?vue&type=script&lang=js"
import style0 from "./documentos.vue?vue&type=style&index=0&id=2a51e0b4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports